import styled from 'styled-components'
import { Button, Col } from 'antd'

export const FinanceIntroWrapper = styled.div`
 
`
export const FinanceIntroCol5 = styled(Col)`
    display: flex;
    justify-content: ${({ index }) => {
        switch (index) {
            case 0:
                return "end";
            case 1:
                return "center";
            case 2:
                return "start";
            case 3:
                return "center";
            case 4:
                return "center";
            default:
                return "black";
        }
    }};
    @media only screen and (max-width: 767px) {
        justify-content: center;
    }
`
export const FinanceIntroCol4 = styled(Col)`
    display: flex;
    justify-content: center;
`
export const FinanceIntroItem = styled.div`
    position: relative;
    max-width: 330px;
    height: 100%;
    width: 100%;
    background: url(${props => props.background}) top center no-repeat;
    background-size: 330px 260px;
    padding: 24px;
    border-radius: 16px;
    border: 1px solid rgba(77, 77, 77, 0.53);
    box-shadow: 7px 4px 6px -3px #00000059;

    @media only screen and (max-width: 375px) {
        max-width: 290px;
    }
`
export const FinanceIntroTitle = styled.div`
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    width: 100%;
    min-height: 74px;
    color: #ffffff;
    overflow-wrap: break-word;
    @media only screen and (max-width: 1200px) {
        font-size: 24px;
    }
`
export const FinanceIntroDesc = styled.div`
  font-size: 18px;
  font-weight: 500;
  text-align: justify;
  color: #575757;
  margin-bottom: 16px;
    margin-top: 160px;
  padding: 0 16px;
  @media only screen and (max-width: 1200px) {
    font-size: 14px;
  }
`
export const FinanceIntroList = styled.li`
  position: relative;
  font-size: 16px;
  font-weight: 700;
  color: #575757;
  border-bottom: 1px solid rgba(77, 77, 77, 0.53);
  padding: 16px 0;
  margin: 0 16px;
  list-style: none;
  @media only screen and (max-width: 1200px) {
    font-size: 14px;
  }
  &:before {
    position: absolute;
    content: '';
    top: 50%;
    transform: translateY(-50%);
    left: -16px;
    width: 4px;
    height: 50%;
    border-radius: 16px;
    background: ${props => props.background};
  }

  &:first-child {
    border-top: 1px solid rgba(77, 77, 77, 0.53);
  }
  &:last-child {
    margin-bottom: 16px;
  }
`
export const FinanceIntroListWrapper = styled.ul`
  padding: 0;
  margin: 0;
`
export const ButtonFinanceWrapper = styled.div`
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: -24px;
  transform: translateX(-50%);
`
export const ButtonFinance = styled(Button)`
  background: ${props => props.background};
  color: #ffffff;
  font-weight: 700;
  font-size: 20px;
  height: 48px;
  padding: 4px 24px;
  border-radius: 32px;
  text-transform: uppercase;
  @media only screen and (max-width: 1200px) {
    font-size: 16px;
  }

  &:hover {
    background: ${props => props.background} !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    font-size: 20px;
    height: 48px;
    border-radius: 32px !important;
  }
`
export const FinanceTextGradientWrapper = styled.div`
  text-align: center;
  width: 60%;
  margin: 56px auto 0 auto;
  @media only screen and (max-width: 768px) {
    margin: 0;
    width: 100%;
    padding-top: 32px;
  }
`
export const FinanceTextGradient = styled.span`
  background: linear-gradient(270deg, #00B74F -22.41%, #1D4289 108.33%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 22px;
  font-weight: 700;
  padding-top: 16px;
  @media only screen and (max-width: 768px) {
    width: 100%;
    display: block;
    font-size: 18px;
    padding: 0 8px;
  }
`